import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import { BlockType, Define } from '@appblocks/codegeneration/types';

export default class DHCP extends BaseFeature {
    constructor() {
        super();
        this.id = 'dhcp';
        this.fileLinks = [
            // 'dhcp\\dhcp.tbs',
            // 'dhcp\\dhcp.tbh',
        ];
        this.files = [
            'libraries/dhcp/dhcp.tbh',
            'libraries/dhcp/dhcp.tbs',
        ];
    }

    getDependencies() {
        return ['sock'];
    }

    getDefines(): Array<Define> {
        const defines = [
            {
                name: 'DHCP_DEBUG_PRINT',
                value: '1',
            },
            {
                name: 'DHCP_POST_FAIL_DELAY',
                value: '30',
            },
            {
                name: 'DHCP_WAIT_TIME',
                value: '8',
            },
        ];

        return defines;
    }

    getCodeBlocks() {
        const blocks = [];

        blocks.push({
            location: 'on_sys_timer',
            blockType: BlockType.CODE,
            template: '    dhcp_proc_timer()',
        });

        blocks.push({
            location: 'on_sock_data_arrival',
            blockType: BlockType.CODE,
            template: '    dhcp_proc_data()',
        });

        blocks.push({
            location: 'DEVICE_TBS',
            blockType: BlockType.LOCATION,
            id: 'callback_dhcp_ok',
            template: `
sub callback_dhcp_ok(renew as no_yes, interface as pl_sock_interfaces, byref ip as string, byref gateway_ip as string, byref netmask as string, lease_time as dword)
    '****callback_dhcp_ok****'
end sub
        `,
        });

        blocks.push({
            location: 'DEVICE_TBS',
            blockType: BlockType.LOCATION,
            id: 'callback_dhcp_failure',
            template: `
sub callback_dhcp_failure(interface as pl_sock_interfaces,failure_code as en_dhcp_status_codes)
    '****callback_dhcp_failure****'
end sub
        `,
        });

        blocks.push({
            location: 'DEVICE_TBS',
            blockType: BlockType.LOCATION,
            id: 'callback_dhcp_pre_clear_ip',
            template: `
sub callback_dhcp_pre_clear_ip(interface as pl_sock_interfaces)
    '****callback_dhcp_pre_clear_ip****'
end sub
        `,
        });

        blocks.push({
            location: 'DEVICE_TBS',
            blockType: BlockType.LOCATION,
            id: 'callback_dhcp_pre_buffrq',
            template: `
sub callback_dhcp_pre_buffrq(required_buff_pages as byte)
    '****callback_dhcp_pre_buffrq****'
end sub
        `,
        });

        blocks.push({
            location: 'DEVICE_TBS',
            blockType: BlockType.LOCATION,
            id: 'callback_dhcp_buff_released',
            template: `
sub callback_dhcp_buff_released()
    '****callback_dhcp_buff_released****'
end sub
        `,
        });

        return blocks;
    }
}
